<template>
  <div class="videopage bookpage bg" :class="{'bgruleHei':show_menu==1}">
    <v-nav @showDownMenu="showDownMenu"></v-nav>
    <mode class="modeapp" v-if="loadMore"></mode>
    <div class="video_main">
      <!--<div class="book_main_box">-->
      <!--<div class="search">-->
      <!--<input type="text" placeholder="输入关键字搜索" v-model="bookPrimary" @keyup.enter="searhcBook">-->
      <!--<div class="searchbtn" @click="searhcBook">搜索</div>-->
      <!--</div>-->
      <!--</div>-->
      <div class="select_main" :class="{'down':more==1}">
        <div class="listoption" @click="showMoreBook">
          {{showtxt}}
          <img src="../../assets/images/phone/show.png">
        </div>
        <div class="select">
          <div class="option" v-for="item in author" @click="changeBookList(item)">{{item.name}}({{item.pdfNum}})</div>
        </div>
      </div>
      <scroller style="top:1.15rem"
                class="scroll"
                :on-refresh="refresh"
                :snapping=true
                :loadingLayerColor="loadMore?'rgba(255,255,255,0)':''"
                :on-infinite="infinite"
                :noDataText="bookList.length == 0  ? '' : '没有更多数据'" ref="myscroller">
              <div class="booklist">
                <div class="item" v-for="item in bookList" @click="lookBook(item)">
                  <div class="bookimg">
                    <img :src="item.image" :alt="item.className">
                  </div>
                  <div class="bookcontent">
                    <div class="book_title textover">《{{item.className}}》</div>
                    <div class="book_content">
                      {{item.pdf_summary}}
                    </div>
                  </div>
                </div>
              </div>
      </scroller>
    </div>
    <div class="no-data" v-if="bookList.length<=0&&!loadMore">
      <img src="../../assets/images/nobook.png" alt="暂无书籍" />
      <div class="notxt">暂无书籍</div>
    </div>
  </div>
</template>

<script>
  import mode from '@/components/bg/mode'
  import router from "../../router";
  export default {
    name: "booklist",
    components:{mode},
    data() {
      return {
        show_menu:0,
        status:'all',
        bookList:[],
        page:0,
        all_page:1,
        bookPrimary:0,
        loadMore:true,
        more:0,
        author:[],
        showtxt:'书库'
      }
    },
    mounted() {
      console.log(this.page)
    },
    methods: {
      showDownMenu(data){
        if(data==0){
          this.show_menu=0
        }else{
          this.show_menu=1
        }
      },
      changeBookList(item){
        this.loadMore=true
        this.more=0
        this.showtxt=`${item.name}`
        this.bookPrimary=item.id
        this.bookList=[]
        this.page=1
        this.getList()
      },
      getBookancestor(){
        this.loadMode=true
        this.$http({
          url: '/Book/ancestor',
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          data: {ajax:1}
        }).then((res) => {
          console.log(res)
          if(res.data.code==0){
            let allNum=0
            res.data.data.map((item,index,arr)=>{
              allNum+=item.pdfNum
            })
            console.log(allNum)
            this.author=res.data.data
            this.author.unshift({id:0,name:'书库',pdfNum:allNum})
            this.getList()
          }else{
            this.$layer.msg(res.data.msg)
          }
        })
          .catch((error) => {
            // error
            this.$layer.msg('网络错误，请稍后重试')
            this.loadMode=false
            console.log(error)
          })
      },
      showMoreBook(){
        if(this.more==1){
          this.more=0
        }else{
          this.more=1
        }
      },
      searhcBook(){
        this.page=1
        this.loadMore=true
        this.getList()
      },
      refresh(done){
        this.page = 1;
        setTimeout(() => {
          this.getList();
          this.$refs.myscroller.finishPullToRefresh();//刷新完毕关闭刷新的转圈圈
        }, 1500);
      },
      infinite(done){
        console.log('---------------------------')
        console.log('infinite')
        console.log(this.page)
        console.log(this.all_page)
        if(this.page>=this.all_page){
          console.log('afdsfjdlsjf')
          setTimeout(()=>{
            this.$refs.myscroller.finishInfinite(true)
          },100)
        }else{
          setTimeout(()=>{
            this.page++
            this.getBookancestor(done)
          },500)
        }
      },
      lookBook(item){
        console.log(item)
        // window.location.href=item.pdf_content
        this.$router.push({name:'appbookdetail',params:{id:item.id}})
      },
      getList(done){
        this.$http({
          url: `/Book/applist`,
          method: 'Post',
          headers: {
            'Content-Type': 'application/json'
          },
          data: {page:this.page,id:this.bookPrimary}
        }).then((res) => {
          console.log(res)
          this.loadMore=false
          if(res.data.code==0){
            this.all_page=Math.ceil(res.data.data.info.page_sum)
            console.log( this.all_page)
            if(res.data.data.data.length>0){
              console.log(222)
              if (this.page == 1) {
                this.bookList = res.data.data.data;
                console.log(23);
              } else {
                console.log(233);
                this.bookList = this.bookList.concat(res.data.data.data);
              }
              this.$refs.myscroller.finishInfinite(true)
              this.page=Math.ceil(res.data.data.info.page_current)
              console.log(this.page)
              console.log(this.bookList)
              // done()
            }
          }else{

            this.$refs.myscroller.finishInfinite(true)
            this.bookList=[]
            this.$layer.msg(res.data.msg)
            if (typeof done == "funtion") {
              console.log("23545");
              done(2)
            }
          }
          // success
        })
          .catch((error) => {
            // error
            console.log(error)
            this.loadMore=false
            this.$refs.myscroller.finishInfinite(true)
            this.$layer.msg('网络错误')
            console.log(error)
          })

      }
    }
  }
</script>
<style>
  .scroll{
    height:calc(100% - 12.36rem);
  }
  .no-data-text{
    line-height: 60px;
  }
</style>
<style scoped lang="scss">
  .bg{
    background: url("../../assets/images/phone/bg.jpg")no-repeat left bottom;
    position: fixed;
    top:0;
    min-height: 100%;
    left:0;
    right:0;
    bottom:0;
    overflow: hidden;
    background-size:100% 100%;
  }
  .videopage{
    .video_main {
      height: calc(100% - 1rem);
      box-sizing: border-box;
      position: relative;
      .search {
        width: 100%;
        height: 0.8rem;
        border: 1px solid #c9a168;
        box-sizing: border-box;
        border-radius: 6px;
        background: #fff;
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding: 0 0.2rem 0 0;
        input {
          width: calc(100% - 1.5rem);
          border: none;
          height: 100%;
          border-radius: 6px;
          padding-left: 0.95rem;
          box-sizing: border-box;
          background: url("../../assets/images/phone/search.png") no-repeat #fff 0.3rem center;
          background-size: 0.38rem auto;
          font-size: 0.28rem;
        }
        .searchbtn {
          width: 1.28rem;
          height: 0.6rem;
          background: #c9a168;
          border-radius: 4px;
          color: #fff;
          font-size: 0.28rem;
          text-align: center;
          line-height: 0.6rem;
        }
      }
      .select_main{
        position: absolute;
        top:0.4rem;
        left:0.28rem;
        width:2.84rem;
        max-height:0.76rem;
        border-radius:3px;
        overflow: hidden;
        transition: max-height 0.5s;
        z-index:1;
        .listoption{
          height:0.76rem;
          line-height: 0.76rem;
          background:#c9a168;
          background-size:0.26rem auto;
          display: flex;
          align-items: center;
          justify-content: center;
          font-size:0.28rem;
          color:#fff;
          img{
            display: block;
            width:0.26rem;
            margin-left:0.2rem;
            transition:transform 0.5s;
            transform: rotate(-90deg);
          }
        }
      }
      .select_main.down{
        max-height:5rem;
        img{
          transform: rotate(0);
        }
      }
      .select{
        /*position: absolute;*/
        z-index:1;
        top:0.76rem;
        left:0;
        width:2.84rem;
        background:rgba(201,161,104,0.9);
        .option{
          height:0.76rem;
          line-height: 0.76rem;
          border-bottom:1px dashed #d5c5ad;
          font-size:0.28rem;
          color:#fff;
          display: flex;
          justify-content: center;
        }
      }
      .book_main_box{
        padding: 0.28rem 0.28rem 0.28rem;
      }
      .booklist{
        background: #fff;
        .item{
          position: relative;
          width:100%;
          box-sizing: border-box;
          border-top:1px solid #c9a168;
          padding:0.35rem 0.28rem;
          min-height:3rem;
          .bookimg{
            position: absolute;
            left:0.28rem;
            top:0.35rem;
            height:2.33rem;
            img{
              width:1.5rem;
              height:2.33rem;
              display: block;
            }
          }
          .bookcontent{
            padding-left:1.8rem;
            box-sizing: border-box;
            width:100%;
            .book_title{
              font-size:0.3rem;
              color:#333333;
              padding-bottom:0.1rem;
            }
            .book_content{
              font-size:0.26rem;
              color:#666;
              overflow: hidden;
              text-overflow: ellipsis;
              cursor:pointer;
              display: -webkit-box;
              -webkit-line-clamp: 5;
              -webkit-box-orient: vertical;

            }
          }
        }
      }
    }
    .no-data{
      position: fixed;
      top:0;
      bottom:0;
      left:0;
      right:0;
      margin:auto;
      width:1.56rem;
      height:1.5rem;
      img{
        width:1.56rem;
        height:1.41rem;
        display: block;
      }
      .notxt{
        text-align: center;
        font-size:0.16rem;
        color:#b68c51;
        padding-top:0.1rem;
      }
    }
  }
  @media (max-device-width: 320px) {
    .book_content{
      font-size:0.26rem;
      color:#333;
      overflow: hidden;
      text-overflow: ellipsis;
      cursor:pointer;
      display: -webkit-box;
      -webkit-line-clamp: 4 !important;
      -webkit-box-orient: vertical;

    }

  }
</style>



// WEBPACK FOOTER //
// src/views/m/booklist.vue